export const LOAD_DISCUSSION = 'Dyzio/Discussion/LOAD_DISCUSSION';
export const LOAD_DISCUSSION_ERROR = 'Dyzio/Discussion/LOAD_DISCUSSION_ERROR';
export const LOAD_DISCUSSION_SUCCESS = 'Dyzio/Discussion/LOAD_DISCUSSION_SUCCESS';

export const CLEAR_DISCUSSION = 'Dyzio/Discussion/CLEAR_DISCUSSION';
export const SET_DISCUSSION = 'Dyzio/Discussion/SET_DISCUSSION';

export const LOAD_SENDBIRD_MESSAGES = 'Dyzio/Discussion/LOAD_SENDBIRD_MESSAGES';
export const LOAD_MORE_MESSAGES = 'Dyzio/Discussion/LOAD_MORE_MESSAGES';

export const SEND_MESSAGE = 'Dyzio/Discussion/SEND_MESSAGE';
export const RECEIVE_MESSAGE = 'Dyzio/Discussion/RECEIVE_MESSAGE';
export const UPDATE_MESSAGES = 'Dyzio/Discussion/UPDATE_MESSAGES';
export const DELETE_MESSAGE = 'Dyzio/Discussion/DELETE_MESSAGE';

export const NEW_DOCUMENT = 'Dyzio/Discussion/NEW_DOCUMENT';
export const UPDATE_DOCUMENTS = 'Dyzio/Discussion/UPDATE_DOCUMENTS';
export const REMOVE_DOCUMENT = 'Dyzio/Discussion/REMOVE_DOCUMENT';
export const APPROVE_DOCUMENT = 'Dyzio/Discussion/APPROVE_DOCUMENT';
export const UNAPPROVE_DOCUMENT = 'Dyzio/Discussion/UNAPPROVE_DOCUMENT';

export const UPDATE_DELIVERABLES = 'Dyzio/Discussion/UPDATE_DELIVERABLES';
export const UPDATE_DELIVERABLE_DOCUMENT = 'Dyzio/Discussion/UPDATE_DELIVERABLE_DOCUMENT';
export const UPDATE_DELIVERABLE_IS_LIVE = 'Dyzio/Discussion/UPDATE_DELIVERABLE_IS_LIVE';

export const UPDATE_DELIVERABLE_APPROVED = 'Dyzio/Discussion/UPDATE_DELIVERABLE_APPROVED';
export const UPDATE_DELIVERABLE_APPROVED_SUCCESS = 'Dyzio/Discussion/UPDATE_DELIVERABLE_APPROVED_SUCCESS';
export const UPDATE_DELIVERABLE_APPROVED_ERROR = 'Dyzio/Discussion/UPDATE_DELIVERABLE_APPROVED_ERROR';

export const SET_DISCUSSION_TYPE = 'Dyzio/Discussion/SET_DISCUSSION_TYPE';

export const UPDATE_CURRENT_BRIEF = 'Dyzio/Discussion/UPDATE_CURRENT_BRIEF';
export const UPDATE_CURRENT_CONTRACT = 'Dyzio/Discussion/UPDATE_CURRENT_CONTRACT';
export const UPDATE_SIGNED_CONTRACT = 'Dyzio/Discussion/UPDATE_SIGNED_CONTRACT';

export const UPDATE_DOCS_STATUS = 'Dyzio/Discussion/UPDATE_DOCS_STATUS';
export const UPDATE_DELIVERABLE_STATUS = 'Dyzio/Discussion/UPDATE_DELIVERABLE_STATUS';
export const UPDATE_BUDGET = 'Dyzio/Discussion/UPDATE_BUDGET';
export const UPDATE_BUDGET_SUCCESS = 'Dyzio/Discussion/UPDATE_BUDGET_SUCCESS';
export const UPDATE_BUDGET_ERROR = 'Dyzio/Discussion/UPDATE_BUDGET_ERROR';

export const UPDATE_TRACKED_ASSETS = 'Dyzio/Discussion/UPDATE_TRACKED_ASSETS';



/** WEBPACK FOOTER **
 ** ./src/containers/discussion/constants.js
 **/